/**
 * Единая точка форматирования цены.
 *
 * Раньше в коде было "400 с" — гости не понимали что такое "с".
 * Теперь единообразно "400 KGS" (или "400 сом" если admin так настроит).
 *
 * Использование:
 *   import { formatPrice } from '../src/utils/formatPrice';
 *   formatPrice(400, settings.currency)  // "400 KGS"
 */
export function formatPrice(amount: number, currency: string = 'KGS'): string {
  // Нормализуем число: без копеек для целых, иначе 2 знака
  const rounded = Math.round(amount * 100) / 100;
  const formatted = Number.isInteger(rounded)
    ? rounded.toString()
    : rounded.toFixed(2);

  // Убираем старые сокращения — "с" одна буква нечитабельно.
  // Также защита от whitespace-only строк: trim + fallback на 'KGS'.
  const cur = (currency || '').trim();
  const displayCurrency = !cur || cur === 'с' ? 'KGS' : cur;

  return `${formatted} ${displayCurrency}`;
}
